<script setup>
import Header from './components/TheSddsHeader.vue';
import { onMounted } from 'vue';
import { useMainStore } from '@/store';
import { getSystemConfig } from './services/leadService';

const store = useMainStore();

const menuItems = [
  { name: 'viewer', text: 'Lead Viewer' },
];

onMounted(() => {
  loadApplicationData();
});

const loadApplicationData = async () => {
  const response = await getSystemConfig();
  store.systemConfig = response.data;
};
</script>

<template>
  <sdds-theme />
  <Header title="Lead Admin Tool" :menu-items="menuItems" />
  <div>
    <router-view />
  </div>
</template>

<style>
html {
  height: 100%;
  background-color: var(--sdds-grey-50);
}

.superpower {
  min-height: calc(100vh - 64px);
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
